import { Box, BoxProps } from '@chakra-ui/react';
import { ReactElement, ReactNode } from 'react';
import { useIntersectionObserverState } from '../../hooks/useIntersectionObserver';

export interface LazyProps extends BoxProps {
  fallback?: ReactNode;
}

const Lazy = ({ fallback, children, ...rest }: LazyProps): ReactElement | null => {
  const { ref, isIntersecting } = useIntersectionObserverState<HTMLDivElement>();

  return (
    <Box ref={ref} {...rest}>
      {isIntersecting ? children : fallback || null}
    </Box>
  );
};
export default Lazy;
